const LAYOUTS = new Set(["widescreen", "vertical", "square", "unknown"]);

// Partition only adjacent items. Never collect later matching formats to fill a row:
// flattening these runs must reproduce the server's globally paginated order exactly.
export const consecutiveAspectRuns = (items) => {
  const runs = [];
  items.forEach((item, index) => {
    const candidate = item.displayGroup || item.coverLayout || "unknown";
    const layout = LAYOUTS.has(candidate) ? candidate : "unknown";
    if (!runs.length || runs[runs.length - 1].layout !== layout) {
      runs.push({ layout, startIndex: index, items: [] });
    }
    runs[runs.length - 1].items.push(item);
  });
  return runs;
};